import React from "react";
import { Route } from "react-router-dom";

import { APP_URLS } from "../../constants/urlConstants";
import CreateTransactions from "../../containers/TransactionsScreen/CreateTransactions";
import NotFound from "../../NotFound/NotFound";
import TruckCareScreen from "../../containers/TruckCareScreen";

const TruckCareRoutes = (props) => {
  const { access = {}, match } = props;
  const { create, read, update } = access;

  return (
    <>
      {!!read && (
        <Route
          exact
          path={match.path}
          render={(routeProps) => (
            <TruckCareScreen {...routeProps}  />
          )}
        />)}
      {!!create && (
        <Route
          path={APP_URLS.TRUCKCARE.ADD_TRUCKCARE}
          component={CreateTransactions}
        />
        )}
      {!!update && (
        <Route
          path={APP_URLS.TRUCKCARE.EDIT_TRUCKCARE}
          render={(routeProps) => (
            <CreateTransactions {...routeProps} isEdit={true} />
          )}
        />
        )}
    
    </>
  );
};

export default TruckCareRoutes;
